export default __webpack_public_path__ + "static/media/phrase.19c5e898.svg";